import { useContext } from 'react';
import { MainViewContext } from '../../../Pages/MainComponents/MainView/MainViewContext';
import { TransitionAction } from '../../../Pages/MainComponents/MainView/MainViewModel';
import ExitRouteService, {
    ExitStatus,
} from '../../../Services/ExitRouteService';
import PatientManagementService from '../../../Services/PatientManagementService';
import { VoidReturn } from '../../../Utils/PageUtils';
import { WarningDialogHandler } from '../Warning/WarningDialog';

export interface IDeviceInfoCheckDialogProps {
    onClose: () => VoidReturn;
}

function useDeviceInfoCheckDialogHandler(
    props: IDeviceInfoCheckDialogProps
): WarningDialogHandler {
    const viewContext = useContext(MainViewContext);
    const { onClose } = props;

    return {
        primaryAction: async () => {
            await PatientManagementService.SetOrionAirDevices();
            if (onClose) onClose();
            viewContext.doTransition(
                TransitionAction.ResetUserDeviceProfileAndWorkflow
            );
        },
        secondaryAction: async () => {
            ExitRouteService.exit(ExitStatus.CompleteSuccess);
        },
    };
}

export default useDeviceInfoCheckDialogHandler;
